module.exports = __webpack_public_path__ + "img/marker.e56d2b5b.svg";